module.exports = __webpack_public_path__ + "teqbahn-assets/media/21.752768f1.jpg";